

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.Cxin0ApN.js","_app/immutable/chunks/disclose-version.bv6as8gS.js","_app/immutable/chunks/runtime.BQe1SyjF.js","_app/immutable/chunks/legacy.BsjUubzt.js","_app/immutable/chunks/render.DqyjfRrq.js","_app/immutable/chunks/lifecycle.BsZaEuyu.js","_app/immutable/chunks/entry.Bf6Bkx5o.js","_app/immutable/chunks/index-client.Cl4XOZi0.js"];
export const stylesheets = [];
export const fonts = [];
